export default __webpack_public_path__ + "static/Volkswagen Polo-6b666b8ce67d27d14304d3f4fc31afcd.png";